document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('[data-faq-item]');

  if (!faqItems.length) return;

  faqItems.forEach(function (item) {
    const button = item.querySelector('[data-faq-toggle]');
    const answerWrapper = item.querySelector('[data-faq-answer]');

    if (!button || !answerWrapper) return;

    // Force all FAQ answers closed initially.
    answerWrapper.style.height = '0px';

    button.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');

      // If current item is already open, close it.
      if (isOpen) {
        closeFaq(item);
        return;
      }

      // Close every other FAQ first.
      faqItems.forEach(function (otherItem) {
        if (
          otherItem !== item &&
          otherItem.classList.contains('is-open')
        ) {
          closeFaq(otherItem);
        }
      });

      // Then open the clicked FAQ.
      openFaq(item);
    });
  });


  function openFaq(item) {
    const button = item.querySelector('[data-faq-toggle]');
    const answerWrapper = item.querySelector('[data-faq-answer]');

    if (!button || !answerWrapper) return;

    item.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');

    answerWrapper.style.height =
      answerWrapper.scrollHeight + 'px';
  }


  function closeFaq(item) {
    const button = item.querySelector('[data-faq-toggle]');
    const answerWrapper = item.querySelector('[data-faq-answer]');

    if (!button || !answerWrapper) return;

    // Set explicit current height before collapsing.
    answerWrapper.style.height =
      answerWrapper.scrollHeight + 'px';

    requestAnimationFrame(function () {
      answerWrapper.style.height = '0px';

      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
    });
  }


  // Keep the open answer height correct after resizing.
  window.addEventListener('resize', function () {
    faqItems.forEach(function (item) {
      if (!item.classList.contains('is-open')) return;

      const answerWrapper =
        item.querySelector('[data-faq-answer]');

      if (!answerWrapper) return;

      answerWrapper.style.height = 'auto';

      const height = answerWrapper.scrollHeight;

      answerWrapper.style.height = height + 'px';
    });
  });
});